import { IconButton } from '@material-ui/core'
import { FC, useEffect } from 'react'
//@ts-ignore
import { useTheme } from 'styled-components'
import { OldSelect } from 'pages/content/components/jobs/components/molecules'
import { ReactComponent as CloseIcon } from 'icons/closed-icon.svg'
import { reportedContentStatus } from 'common/select-options/reportedContentStatus'
import { reportedContentType } from 'common/select-options/reportedContentType'
import { reportedUserStatus } from 'common/select-options/reportedUserStatus'
import {
  StyledDrawer,
  StyledLabel,
  StyledContentWrapper,
  StyledBox,
  StyledSelectContainer
} from './styled'
import { AnalyticUserType, useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { observer } from 'mobx-react'
import { ReportedContentState } from 'models/reported-content/reported-content.store'
import { Button } from 'common/atoms/Button/Button'

export type Filters = {
  status?: string
  type?: string
}
interface IFilterProps {
  actionType: string
}

const initialState = {
  status: '',
  type: '',
}

const SearchFilterDrawer: FC<IFilterProps> = ({
  actionType,
}) => {
  const theme = useTheme()
  const { handleTracker } = useAnalytics()
  const { backendUser, backendPartner } = useAuth()
  const { 
    isDrawerOpen,
    setIsDrawerOpen,
    filters,
    setFilters,
    showTypeFilter,
    setPage,
    setTotalCount,
    setReportedContents,
  } = ReportedContentState
  const onSelect = async event => {
    setTotalCount(0)
    setPage(1)
    setReportedContents([])
    const value = event?.target?.value
    const name = event?.target?.name
    const logData = {
      'User ID': backendUser?.id,
      'Account Type': backendUser?.partnerId ? 'Partner' : backendUser?.role,
      'Partner ID': backendPartner?.id,
      'Company Name': backendPartner?.name
    }

    setFilters(preValues => {
      logData['status'] = preValues.status || undefined
      logData['type'] = preValues.type || undefined
      logData[name] = value
      return { ...preValues, [name]: value }
    })
    await handleTracker(AnalyticUserType.ALL, `Filter Reported ${actionType}`, logData, 'mixpanel', null, backendUser)
  }

  const onReset = async () => {
    setReportedContents([])
    setFilters(initialState)
    const logData = {
      'User ID': backendUser?.id,
      'Account Type': backendUser?.partnerId ? 'Partner' : backendUser?.role,
      'Partner ID': backendPartner?.id,
      'Company Name': backendPartner?.name
    }
    await handleTracker(
      AnalyticUserType.ALL,
      `Reset Filter Reported ${actionType}`,
      logData,
      'mixpanel',
      null,
      backendUser
    )
  }

  useEffect(() => {
    if (filters) return
    setFilters(initialState)
  }, [])

  return (
    <StyledDrawer
      anchor="right"
      open={isDrawerOpen}
      onOpen={() => setIsDrawerOpen(true)}
      onClose={() => setIsDrawerOpen(false)}
      title="Filter"
    >
      <StyledContentWrapper key={Math.random()}>
        <StyledBox>
          <StyledLabel fontSize="20px">Filter</StyledLabel>
          <IconButton onClick={() => setIsDrawerOpen(false)}>
            <CloseIcon />
          </IconButton>
        </StyledBox>
        <StyledSelectContainer>
          <OldSelect
            name="status"
            label={<StyledLabel>Status</StyledLabel>}
            defaultValue={actionType === "Content" ? reportedContentStatus[0].label : reportedUserStatus[0].label}
            value={filters?.status}
            menuItemList={actionType === "Content" ? reportedContentStatus : reportedUserStatus}
            theme={theme}
            autoWidth={false}
            onChange={onSelect}
            width="100%"
            multiple={false}
            native={false}
          />
          {showTypeFilter && (
            <OldSelect
              name="type"
              label={<StyledLabel>Type</StyledLabel>}
              defaultValue={reportedContentType[0].label}
              menuItemList={reportedContentType}
              value={filters?.type}
              theme={theme}
              autoWidth={false}
              onChange={event => onSelect(event)}
              width="100%"
              multiple={false}
              native={false}
            />
          )}
          <Button design='tertiary' disabled={filters?.status === '' && filters?.type === ''} onClick={onReset}>
            Reset
          </Button>
        </StyledSelectContainer>
      </StyledContentWrapper>
    </StyledDrawer>
  )
}

export default observer(SearchFilterDrawer)
